<template>
  <DBox
    :id="'cmp-catalog-products-only_tracks'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="$t('add_new_media')"
    @addClick="addProductMedia"
  >
    <div class="ut-fh">
      <NTable
        class="invcoie-line-list dbox1"
        :headers="headers"
        :items="list"
        :config="tableConfig"
        :id="'accounting-invoices-invoice_line'"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('media')">
              <span>{{ item["set_no"] }}</span>
            </td>
            <td v-bind="tdcon('no')">
              <span>{{
                item["seq_no"]
              }}</span>
            </td>
            <td v-bind="tdcon('artist')">
              <span  class="ut-link ut-text-accent5" >{{ item["artist"] }}</span>
            </td>
            <td v-bind="tdcon('title_text')">
              <span>{{ item["title"] }}</span>
            </td>
            <td v-bind="tdcon('version')">
              <span>{{ item["version"] }}</span>
            </td>
            <td v-bind="tdcon('isrc')">
              <span>{{ item["isrc"] }}</span>
            </td>
            <td v-bind="tdcon('digital_rights')">
                <Dropdown2
                    class="dbox1"
                    :showLabel="false"
                
                    :options="rightsTV"
                    :placeholder="$t('digital_rights')"
                    :selected="rightsTV.find(v => v.value == item.digital_right_type)"
                    v-on:selectedChange="e => onDropDownChange('digital_right_type', e, item)"
                    :bb="'0px'"
                >
                </Dropdown2>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<script>
import { openMailWindow } from "@/utility";
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import TextField from "@plugins/text-field/text-field";

import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

export default {
  components: {
    TextField,
    NTable,
    DBox,
  },
  props: {
    selectedProductDetails: {
      required: true,
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("media", {mw:50}),
        createTableHeader("no",{text:'No',mw:30}),
        createTableHeader("artist"),
        createTableHeader("title_text",{ text:'title'}),
        createTableHeader("version",{ }),
        createTableHeader("isrc", {  mw:110}),
        createTableHeader("digital_rights", { text:'digital rights'})
      ];
    },
    list: function () {
      return this.selectedProductDetails.only_tracks || [];
    },
    rightsTV:function(){
      return [
          { text:"Full Rights",value:"1" },
          { text:"Bundle Only",value:"2" },
          { text:"No Digital Rights",value:"3" },
      ]
    }
  },
  methods: {
    onDropDownChange:function(name,e,item){
        console.log(e.value,name,item);
        const payload = {
            kVal:  item.track_id,
            name:  name,
            value: e.value
        }
        this.$emit("change",payload)
    },

    addProductMedia:function(){
          this.$router.push({
        ...this.$route,
        query: {
          modal: "add_product_media",
          external_id:this.selectedProductDetails.product.product_id
        },
      });
    }
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-catalog-products-only_tracks{
  .dt-ntable {
    th.exclude {
      span {
        /* margin: 0px 8px; */
      }
    }
  }
}
</style>
